import { render, staticRenderFns } from "./VisitScheduleSwitch.vue?vue&type=template&id=4ac899c9&"
import script from "./VisitScheduleSwitch.vue?vue&type=script&lang=js&"
export * from "./VisitScheduleSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports